export default __webpack_public_path__ + "static/media/Animals19.1f0f2c6a.jpg";